import { useCallback, useState } from "react";

const useToggleState = initialValue => {
  const [value, setValue] = useState(initialValue);

  const toggle = useCallback(() => {
    setValue(v => !v);
  }, []);

  return [value, toggle, setValue];
};

export default useToggleState;
